import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';


@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'configuracao';
    this.token = new Login();
  }

  detalhar(){
    return this.http.get<Object[]>(this.url);
  }

  atualizar(p : any) {
    return this.http.put<Object[]>(this.url, p, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
